angular.module('app.entity.actions', [
    'event',
    'gettext',
    'inetsys.messages',
    'inetsys.modal',
]);
